import { useEffect, useState } from 'react';

import { AlienationActiveSolutionDto } from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';
import { backAlertMessage } from 'hooks/utils/backAlertMessage';

function useActiveAlienationSolution():
  | AlienationActiveSolutionDto
  | undefined {
  const controller = useApi().AdminFonctionnelControllerApi;
  const [activeSolution, setActiveSolution] = useState<
    AlienationActiveSolutionDto | undefined
  >();

  useEffect(() => {
    controller
      .getAlienationActiveSolutionUsingGET()
      .then(solution => setActiveSolution(solution))
      .catch((err: Response) => backAlertMessage(err, false));
  }, [controller]);

  return activeSolution;
}

export default useActiveAlienationSolution;
